import { useMediaQuery } from '@mui/material';
import theme from '../libs/mui/theme';

const { sm = 768, md = 992, lg = 1200 } = theme.breakpoints?.values ?? {};

export type ViewportRange = 'sm' | 'md' | 'lg' | 'compact' | 'xl';

const viewportQueries: Record<ViewportRange, string> = {
  sm: `(max-width: ${sm - 1}px)`,
  md: `(min-width: ${md}px) and (max-width: ${lg - 1}px)`,
  lg: `(min-width: ${lg}px)`,
  compact: `(max-width: 1439px), (max-height: 849px)`,
  xl: `(min-width: 1536px)`,
};

export const useViewport = (range: ViewportRange): boolean => {
  return useMediaQuery(viewportQueries[range]);
};
